import { authRequest } from "features/authentication";

export const changePassword = (newPassword, currentPassword) => async (dispatch, getState) => {
        await dispatch(authRequest('/auth/password', {
            method:'PUT',
            body: {newPassword, currentPassword},
            errorToast:true
        }));
    
};